import styles from "../MoveOutChecklist.module.css";

export const PhaseBanner = ({ type, icon, title, sub }) => {
    const cls = { blue: styles.pbBlue, amber: styles.pbAmber, green: styles.pbGreen }[type];
    return (
        <div className={`${styles.pb} ${cls}`}>
            <i className={`ti ti-${icon} ${styles.pbIcon}`} />
            <div>
                <div className={styles.pbTitle}>{title}</div>
                <div className={styles.pbSub}>{sub}</div>
            </div>
        </div>
    );
}

export const Badge = ({ type, children }) => {
    const cls = {
        blue: styles.badgeBlue,
        success: styles.badgeSuccess,
        warn: styles.badgeWarn,
        danger: styles.badgeDanger,
        muted: styles.badgeMuted,
    }[type] || styles.badgeMuted;
    return <span className={`${styles.badge} ${cls}`}>{children}</span>;
}

export const InfoBox = ({ type, icon, children }) => {
    const cls = { blue: styles.ibBlue, amber: styles.ibAmber, green: styles.ibGreen, red: styles.ibRed }[type];
    return (<div className={`${styles.ib} ${cls}`}>
        <i className={`ti ti-${icon}`} />
        <div>{children}</div>
    </div>);
}